import React from "react";

type Props = {
  zoom?: boolean;
  swiperWidth?: number | string;
  children?: React.ReactNode;
};

const SwiperPage: React.FC<Props> = (props) => {
  return (
    <div className="swiper-slide" style={{ width: props.swiperWidth }}>
      {props.zoom ? (
        <div className="swiper-zoom-container">{props.children}</div>
      ) : (
        props.children
      )}
    </div>
  );
};

export default SwiperPage;
